<script setup lang="ts">
import Banner from '~/shared/ui/banner/Banner.vue';
import {
  BANNER_SITE_TOP_DESKTOP_PARAMS,
  BANNER_SITE_TOP_TABLET_PARAMS,
  BANNER_SITE_TOP_MOBILE_PARAMS,
} from '~/shared/lib/banners';

const PLACEHOLDER_HEIGHTS = {
  xs: '480/200',
  mobile: '480/200',
  mobileBig: '600/118',
  tablet: 150,
  tabletBig: 200,
  desktop: 200,
};

const isLoaded = ref(false);
</script>

<template>
  <div :class="[$style.banner, { [$style.banner_loaded!]: isLoaded }]">
    <Banner
      :config="[
        BANNER_SITE_TOP_DESKTOP_PARAMS,
        BANNER_SITE_TOP_TABLET_PARAMS,
        BANNER_SITE_TOP_MOBILE_PARAMS,
      ]"
      align="center"
      width="100%"
      :show-placeholder="true"
      :placeholder-heights="PLACEHOLDER_HEIGHTS"
      @loaded="isLoaded = true"
    />
  </div>
</template>

<style module lang="scss">
.banner {
  display: block;
  margin: 0 auto;

  &_loaded {
    border-bottom: 1px solid var(--color-gray-line);
  }
}

@media (max-width: 599px) {
  .banner {
    text-align: center;
    width: 100%;
  }
}
</style>
